import React from 'react'
import { css } from '@emotion/react'
import { connect } from 'react-redux'
import { doTogglePinExpandedReplyFormHeader } from 'actions/app'
import { selectPrefersExpandedReplyHeader } from 'selectors/app'

const select = state => ({
  expandedHeader: selectPrefersExpandedReplyHeader(state),
})

const perform = {
  onClick: doTogglePinExpandedReplyFormHeader,
}

const pinIconStyle = props => theme => css`
  font-size: ${theme.spacing['10']};
  align-self: center;
  color: ${props.expandedHeader
    ? theme.color.primary.brand
    : theme.color.monochrome.mediumDark};
  cursor: pointer;

  &:not(:last-child) {
    margin-right: ${theme.spacing['7']};
  }
`

function PinIcon(props) {
  const { onClick } = props

  return (
    <div
      className="Icon Icon-pin-filled"
      css={pinIconStyle(props)}
      onClick={onClick}
    />
  )
}

export default connect(select, perform)(PinIcon)
